

import './button.component.scss'
import { Loader } from '../';

const Button = ({isLoading, className , children, onClick, type='button'}) =>
(<button {...{type}} className={`button-component btn btn-default virgin-button ${className ?? ''}`} disabled={isLoading} {...{onClick}}>{children} {isLoading && <Loader className='button-component__loader' />}</button>);

export default Button;